import { render, staticRenderFns } from "./ModalAuditoriaSala.vue?vue&type=template&id=cbfe818a&scoped=true"
import script from "./ModalAuditoriaSala.vue?vue&type=script&lang=js"
export * from "./ModalAuditoriaSala.vue?vue&type=script&lang=js"
import style0 from "./ModalAuditoriaSala.css?vue&type=style&index=0&id=cbfe818a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfe818a",
  null
  
)

export default component.exports